// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2IxTT","dragIcon":"Choice_dragIcon__3kkeY","left":"Choice_left__3CGpD","input":"Choice_input__wtF1t"};